import { chakra } from '@chakra-ui/react';
import { forwardRef as forwardRefChakra } from '@chakra-ui/react';

// @doc https://chakra-ui.com/docs/features/chakra-factory
export const componentFactory = chakra;

// ForwardRef useful for tooltip: https://chakra-ui.com/docs/overlay/tooltip#using-custom-components
export const forwardRef = forwardRefChakra;
